import React, { useEffect, useState, ReactNode, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, isNumber, round } from 'lodash';
import { init } from 'echarts';

import Color from '@tool/color';
import moIndustry from '../../store/industry';
import Empty from '@/component/empty';

interface IProps {}
interface IState {}

const EffectChart = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const effectRef = useRef<any>(null);
  let chart: any = null;
  const { effectList } = moIndustry;
  const getYdata = useMemo(() => {
    const Ydata:any = [];
    const data:any = [];
    effectList?.revenue_per_staff_trend?.forEach((res:any) => {
      Ydata.push(res.year);
      data.push(res.p50 / 10000);
    });
    return { Ydata, data };
  }, [effectList]);

  const render = () => {
    if (chart) chart.dispose();
    chart = init(effectRef.current);
    const option = {
      color: Color.primary,
      legend: {
        show: false,
      },
      grid: {
        left: 0,
        right: 60,
        bottom: 0,
        top: 20,
        containLabel: true,
      },
      xAxis: {
        type: 'value',
        axisLine: {
          show: false,
          lineStyle: { color: Color.ccc },
        },
        splitNumber: 4,
        axisTick: { show: false },
        axisLabel: {
          show: false,
          formatter: (val: number) => {
            if (val === 0) return 0;
            return `${Number(val).toLocaleString()}`;
          },
          fontSize: 10,
          color: Color.blackColor(0.5),
          fontFamily: ' Roboto',
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: Color.blackColor(0.08),
            width: 1,
            type: 'dashed',
          },
        },
      },
      yAxis: {
        type: 'category',
        data: getYdata.Ydata,
        axisTick: { show: false },
        axisLine: {
          lineStyle: { color: Color.ec },
        },
        axisLabel: {
          color: Color.blackColor(0.85),
          fontFamily: 'Roboto',
        },
      },
      series: [
        {
          name: '人效',
          type: 'bar',
          barWidth: 20,
          label: {
            show: true,
            fontFamily: 'Roboto',
            position: 'right',
            formatter: (parme: any) => {
              if (parme.value === 0) return 0;
              return `${round(Number(parme.value), 1).toLocaleString()}`;
            },
          },
          itemStyle: {
            borderRadius: [0, 2, 2, 0],
          },
          data: getYdata.data,
        },
      ],
    };
    chart.setOption(option, true);
  };

  useEffect(() => {
    if (!isEmpty(effectList?.revenue_per_staff_trend)){
      render();
    }
    window.addEventListener('resize', render);
    return () => {
      window.removeEventListener('resize', render);
    };
  }, [getYdata]);

  return <section>
    {!isEmpty(effectList?.revenue_per_staff_trend) ?
      <section className="effect-chart" ref={effectRef} /> : <Empty height='auto'/>}
  </section>;
};

export default observer(EffectChart);
